import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'
import { createDesignerData } from 'designer/component/action/Design'

const getRuleOpenModalAction = (action = {}) => {
  return objectPath.get(action, 'openModal.modal') || action.modal || {}
}

const getRuleOpenModalTarget = (
  action = {},
  modalAction = {},
  target = '',
) => {
  return (
    modalAction.formCode ||
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const clearRuleModalCondition = (action = {}, modalAction = {}, formData) => {
  let formId = action.formId || modalAction.formId
  if (formId) {
    objectPath.set(formData, `@condition.${formId}`, {})
  }

  return formData
}

const getRuleModalProps = (modalAction = {}) => {
  let props = objectPath.get(modalAction, 'props')
  if (!props) return []
  if (Array.isArray(props)) return props
  if (typeof props === 'object') return Object.values(props)
  return []
}

const getRuleOpenModalUi = (designContext = {}, action = {}, modalCode) => {
  let { jsonForm = {} } = designContext
  let actionKey = action.key || ''
  if (!actionKey || actionKey === modalCode) {
    return {
      openKey: modalCode,
      ui: { key: modalCode },
      isHasUi: false,
    }
  }

  let ui = getCurrentUi(actionKey, jsonForm.schema, jsonForm.uischema)
  if (ui?.key !== actionKey) {
    return {
      openKey: modalCode,
      ui: { key: modalCode },
      isHasUi: false,
    }
  }

  return {
    openKey: actionKey,
    ui,
    isHasUi: true,
  }
}

const setRuleOpenModalElementAction = (
  elementAction = {},
  action = {},
  modalCode,
) => {
  objectPath.set(elementAction, ['openModal', modalCode], true)
  if (action.key && action.key !== modalCode) {
    objectPath.set(elementAction, ['openModal', action.key], true)
  }

  return elementAction
}

export const onRuleOpenModal = (
  designContext = {},
  action = {},
  data = {},
  target = '',
) => {
  let {
    jsonForm = {},
    searchData = {},
    elementAction = {},
    setElementAction,
    setDesignerPropsData,
    setOpenModal,
    isUiChanged = {},
    setIsUiChanged,
  } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let modalAction = getRuleOpenModalAction(action)
  let modalCode = getRuleOpenModalTarget(action, modalAction, target)
  if (!modalCode) return undefined

  modalAction = {
    ...modalAction,
    formCode: modalAction.formCode || modalCode,
  }

  if (data.isCloseModal) {
    objectPath.set(isUiChanged, 'modal', {})
    if (setIsUiChanged) setIsUiChanged(isUiChanged)
    return { formData, elementAction }
  }

  formData = clearRuleModalCondition(action, modalAction, formData)
  elementAction = setRuleOpenModalElementAction(
    elementAction,
    action,
    modalCode,
  )
  if (setElementAction) setElementAction(elementAction)

  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  objectPath.set(designerPropsData, 'modal', modalCode)
  objectPath.set(designerPropsData, 'sourceType', modalAction.sourceType || '')
  designerPropsData = createDesignerData(
    designerPropsData,
    searchData,
    formData,
    getRuleModalProps(modalAction),
  )
  if (setDesignerPropsData) setDesignerPropsData(designerPropsData)

  let { openKey, ui, isHasUi } = getRuleOpenModalUi(
    designContext,
    action,
    modalCode,
  )
  if (setOpenModal) setOpenModal(openKey)

  objectPath.set(isUiChanged, 'modal', {
    key: true,
    ui,
    modalAction,
    isRuleOpenModal: true,
    isOpenModal: true,
    isOpening: false,
    designerPropsData,
    isHasUi,
  })
  objectPath.set(isUiChanged, 'isModalRender', modalCode)
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: openKey,
    modalAction,
    designerPropsData,
  }
}
